export const LOADER_TYPE_SDP_TEST = 'SDP_CLASS_TEST'
export const LOADER_TYPE_NORMAL_LESSON = 'NORMAL_LESSON'
